import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from 'classnames';
import commonClasses from './SubscriptionCard.module.scss';
import pingoClasses from './styles/pingo.module.scss';
import logicLikeClasses from './styles/logicLike.module.scss';
import musicClasses from './styles/music.module.scss';
import kionClasses from './styles/kion.module.scss';
import leoniClasses from './styles/leoni.module.scss';
import launcherClasses from './styles/launcher.module.scss';
import soonClasses from './styles/soon.module.scss';
import skillboxClasses from './styles/skillbox.module.scss';
import robloxClasses from './styles/roblox.module.scss';
import likeeClasses from './styles/likee.module.scss';
import { CardArrowRightIcon } from '@icons';
import Button from '@shared/Button/Button';
import { useWindowSize } from '@hooks/useWindowSize';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isSafariSelector, versionSelector } from '@store/models/user/selectors';
import { triggerMetricsEvent } from '@metrics';
import { subscriptionStatusesSelector } from '@store/models/subscription/selectors';
import Picture from '@shared/Picture/Picture';
import { tariffPlanSelector } from '@store/models/subscription/selectors';
import Link from '@shared/Link/Link';
const classesMap = {
    pingo: pingoClasses,
    logicLike: logicLikeClasses,
    music: musicClasses,
    kion: kionClasses,
    leoni: leoniClasses,
    launcher: launcherClasses,
    soon: soonClasses,
    skillBox: skillboxClasses,
    likee: likeeClasses,
    roblox: robloxClasses,
};
const SubscriptionCard = ({ element, withoutBage = false, isButtonShown, children, variant = 'link' }) => {
    const version = useSelector(versionSelector);
    const { parent: { active: isParentActive, draft: isParentDraft, childAdd: isChildAdd }, child: { active: isChildActive }, } = useSelector(subscriptionStatusesSelector);
    const isSafari = useSelector(isSafariSelector);
    const tariffPlan = useSelector(tariffPlanSelector);
    const { isMobileSm, isDesktopLgExtraLg } = useWindowSize();
    const navigate = useNavigate();
    const classes = classesMap[element.name];
    const { alt: bageAlt, src: bageSrc } = element.bage;
    const { alt: imgAlt, src: imgSrc } = element.img;
    const handleMouseDown = (ev) => {
        if (!element.externalLink) {
            return;
        }
        const target = ev.target;
        const isButton = target.tagName === 'BUTTON';
        const isSubscriptionActive = (isParentDraft && isChildActive) || isParentActive || isChildAdd;
        const cardMetricName = isSubscriptionActive ? `${element.name}Active` : element.name;
        const buttonMetricName = `${cardMetricName}Button`;
        const sendMetricName = isButton ? buttonMetricName : cardMetricName;
        triggerMetricsEvent({ element: sendMetricName });
        window.location.href = element.externalLink;
    };
    const getBageClasses = (position) => classNames(commonClasses.infoBage, commonClasses[position], classes.infoBage, { [commonClasses.safari]: isSafari });
    const content = (_jsxs(_Fragment, { children: [_jsx("div", { className: classNames(commonClasses.bubbleContainer, classes.bubbleContainer), children: _jsx("div", { className: classNames(commonClasses.bubble, classes.bubble) }) }), _jsx(Picture, { alt: imgAlt, src: imgSrc, containerClass: classNames(commonClasses.imgContainer, classes.imgContainer), className: commonClasses.img }), !withoutBage && (_jsx("div", { className: classNames(commonClasses.bages, classes.bages), children: _jsx("img", { className: commonClasses.bage, alt: bageAlt, src: `/images/${bageSrc.directory}/${bageSrc.fileName}` }) })), _jsxs("div", { className: classNames(commonClasses.textWrap, classes.textWrap), children: [_jsx("p", { className: getBageClasses('top'), children: element.getPurchaseMethod(tariffPlan) }), _jsx("h3", { className: classNames(commonClasses.title, classes.title), children: element.title }), _jsxs("p", { className: classNames(commonClasses.text, classes.text), children: [element.text, "\u00A0", !element.hideTextArrow && _jsx(CardArrowRightIcon, { containerClasses: commonClasses.iconRight })] }), children && isMobileSm && _jsx("div", { className: classes.children, children: children }), element.purpose && !isButtonShown && _jsx("p", { className: getBageClasses('bottom'), children: element.purpose }), isButtonShown && (_jsx(Button, { className: classNames(commonClasses.button, classes.button), variant: "alwaysWhite", size: isMobileSm ? 'sm' : isDesktopLgExtraLg ? 'lg' : 'md', text: element.getButtonText(tariffPlan), full: isMobileSm, stopBubbling: true }))] }), children && !isMobileSm && _jsx("div", { className: classes.children, children: children })] }));
    const cardClasses = classNames(commonClasses.card, classes.card, classes[version], commonClasses[version]);
    const resultMap = {
        div: (_jsx("div", { className: cardClasses, onMouseDown: handleMouseDown, children: content })),
        link: (_jsx(Link, { href: element.externalLink || '', className: cardClasses, children: content })),
    };
    return resultMap[variant];
};
export default SubscriptionCard;
